import request from '@/utils/request.js'

const mallUrl = process.env.VUE_APP_MALL_API

// --------------------------- 商城员工管理接口 ----------------------
// 获取商城员工列表
export function getMallEmployeeListApi(params) {
  return request({
    url: `${mallUrl}/platform/malls/oneself/employees/page`,
    method: 'get',
    params
  })
}

// 获取商城员工详情
export function getMallEmployeeDetailApi(mallEmployeeId) {
  return request({
    url: `${mallUrl}/platform/malls/oneself/employees/${mallEmployeeId}`,
    method: 'get'
  })
}

// 添加商城员工
export function addMallEmployeeApi(data) {
  return request({
    url: `${mallUrl}/platform/malls/oneself/employees`,
    method: 'post',
    data
  })
}

// 编辑商城员工
export function editMallEmployeeApi(data, mallEmployeeId) {
  return request({
    url: `${mallUrl}/platform/malls/oneself/employees/${mallEmployeeId}`,
    method: 'put',
    data
  })
}

// 获取商城权限路由
export function getMallRightMenuListApi() {
  return request(
    {
      url: `${mallUrl}/platform/menus`,
      method: 'get'
    },
    false
  )
}

// --------------------------- 商户员工管理接口 ----------------------
// 分页查询店铺列表
export function getSellListApi(companyId) {
  return request({
    url: `${mallUrl}/workbench/companies/${companyId}/shops`,
    method: 'get'
  })
}

// 获取商户员工列表
export function getSellEmployeeListApi(params, shopId) {
  return request({
    url: `${mallUrl}/seller/shops/${shopId}/employees/page`,
    method: 'get',
    params
  })
}

// 获取商户员工详情信息
export function getSellEmployeeDetailApi(shopEmployeeId, shopId) {
  return request({
    url: `${mallUrl}/seller/shops/${shopId}/employees/${shopEmployeeId}`,
    method: 'get'
  })
}

// 新增商户员工
export function addSellEmployeeApi(data, shopId) {
  return request({
    url: `${mallUrl}/seller/shops/${shopId}/employees`,
    method: 'post',
    data
  })
}

// 编辑商户员工
export function editSellEmployeeApi(data, shopEmployeeId, shopId) {
  return request({
    url: `${mallUrl}/seller/shops/${shopId}/employees/${shopEmployeeId}`,
    method: 'put',
    data
  })
}

// 获取商城权限路由
export function getSellRightMenuListApi() {
  return request(
    {
      url: `${mallUrl}/seller/menus`,
      method: 'get'
    },
    false
  )
}

/** ***********订单审批**************** */
// 查询订单详情
export function getOrderDetailApi(orderId) {
  return request({
    url: mallUrl + `/buyer/shopping-orders/${orderId}`,
    method: 'get'
  })
}

// 获取订单物流信息
export function getOrderLogisticsApi(orderId) {
  return request({
    url: mallUrl + `/order/${orderId}/logistics`,
    method: 'get'
  })
}
